import { render, staticRenderFns } from "./AdminTeamTrendCard.vue?vue&type=template&id=27a4fc3c"
import script from "./AdminTeamTrendCard.vue?vue&type=script&lang=js"
export * from "./AdminTeamTrendCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports